"use strict";

exports.__esModule = true;
exports.ABROAD_CODES = void 0;
// 海外区域编码
var ABROAD_CODES = ['990000', '990100'];
exports.ABROAD_CODES = ABROAD_CODES;